import BaseService from './base.service';
import HTTPClient from '../http-client';
import { CheckDeviceExistenceResponse } from '@/common/model/response/check-device-existence-response.model';
import { DeviceRegisterResponse } from '@/common/model/response/device-register-response.model';
import { MstDeviceType } from '@/common/enum/mst-device-type.enum';
import { CreateDeviceResponse } from '@/model/response/create-device-response.model';

export default class DeviceService extends BaseService {
  private DEVICE_REGISTER = `plusHub/hubDevice/add`;
  private CHECK_DEVICE_EXISTENCE = `/func/check-device-existence`;
  private CREATE_MASTER_DEVICE = `/func/create-master-device`;

  public async deviceRegister(uuid: string): Promise<DeviceRegisterResponse> {
    const dataResponse = await HTTPClient.getInstance().httpUsers.post<DeviceRegisterResponse>(this.DEVICE_REGISTER, {
      uuid
    });
    const resultResponse = HTTPClient.convertAxiosResponseToResponse(dataResponse);
    return resultResponse;
  }

  public async checkDeviceExistence(
    externalDeviceId: string,
    externalDeviceType: number
  ): Promise<CheckDeviceExistenceResponse> {
    const dataResponse = await this.HTTP_WITHOUT_MSG.get<CheckDeviceExistenceResponse>(this.CHECK_DEVICE_EXISTENCE, {
      params: {
        externalDeviceId,
        externalDeviceType
      }
    });
    const resultResponse = HTTPClient.convertAxiosResponseToResponse(dataResponse);
    return resultResponse;
  }

  public async createDevice(externalDeviceId: string): Promise<CreateDeviceResponse> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const authMode = config && config['AUTH_MODE'];
    const axios = authMode ? HTTPClient.getInstance().HTTP : HTTPClient.getInstance().HTTP_WITH_DELAYED_MSG;
    const dataResponse = await axios.post<CreateDeviceResponse>(this.CREATE_MASTER_DEVICE, {
      externalDeviceId,
      type: MstDeviceType.HT
    });
    const resultResponse = HTTPClient.convertAxiosResponseToResponse(dataResponse);
    return resultResponse;
  }
}
